import { Type } from "@sinclair/typebox";

export const UUID_PATTERN =
  "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$";

export const UuidSchema = Type.String({ pattern: UUID_PATTERN });

export const MATRIX_ROOM_ID_PATTERN = "^!\\S+$";

export const MatrixRoomIdSchema = Type.String({
  minLength: 2,
  maxLength: 255,
  pattern: MATRIX_ROOM_ID_PATTERN
});

declare const roomIdBrand: unique symbol;

export type RoomIdV1 = string & { readonly [roomIdBrand]: "RoomIdV1" };

export const ProjectIdSchema = UuidSchema;
export const RoomIdSchema = MatrixRoomIdSchema;

export function createUuidSchema() {
  return Type.String({ pattern: UUID_PATTERN });
}
